import {useTranslation} from 'react-i18next'
import {isSupportedLanguage} from '~/utils/locales'
import {getLocalizedPath, WebsitePath} from '~/utils/routes'

export const useLocalizedPath = (path: WebsitePath, overrideLocale?: string) => {
  const {i18n} = useTranslation()
  const locale = overrideLocale || i18n.language

  if (!isSupportedLanguage(locale)) {
    console.warn(`Unsupported language: ${locale}`)
    return path
  }

  return getLocalizedPath({path, language: locale}) ?? path
}
